import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'

import MissionProfileConfig from './MissionProfileConfig'

import styles from './styles.scss'


class MissionProfile extends Component {
  render() {
    const {
      values,
      missionProfileAdd,
      missionProfileRemove,
      missionProfileUpdate,
      powerOnAdd,
      powerOnRemove,
      powerOnUpdate,
      powerOffAdd,
      powerOffRemove,
      powerOffUpdate
    } = this.props

    return (
      <Flex styleName="MissionProfileWrapper">
        <MissionProfileConfig
          values={values}
          mpAdd={missionProfileAdd}
          mpRemove={missionProfileRemove}
          mpUpdate={missionProfileUpdate}
          powerOnAdd={powerOnAdd}
          powerOnRemove={powerOnRemove}
          powerOnUpdate={powerOnUpdate}
          powerOffAdd={powerOffAdd}
          powerOffRemove={powerOffRemove}
          powerOffUpdate={powerOffUpdate}
        />
      </Flex>
    )
  }
}

export default CSSModules(MissionProfile, styles)
